export default {
    discipleTree: null,
    error: ''
};
